/* unplugin-vue-components disabled */
import $global from 'stores/global'
import $chats from 'stores/chats'
import Rest from 'utils/rest'
import Duplicate  from './duplicate.vue'
import ShareError from './share-error.vue'
import ShareSkeleton from './share-skeleton.vue'
import {API_SHARE_CHAT} from 'consts/api'

export default {
  components: {
    Duplicate,
    ShareError,
    ShareSkeleton
  },
  data(){
    return {
      copying: false,
      owner: undefined,
      error: undefined
    }
  },
  computed:{
    chat_id(){
      return this.$route.query.id
    },
    size(){
      if (this.$responsive.desktop) {
        return '54.4rem'
      }
      return '90%'
    }
  },
  async mounted(){
    if (typeof this.chat_id !== 'string' || !/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(this.chat_id)) {
      $utils.toasts.error('Invalid shared chat link. Please check and try again.')
      this.goToChats()
      return
    }
    this.$refs.modal.open()
    try {
      const $rest = new Rest()
      this.owner = await $rest.get(`${API_SHARE_CHAT}/owner/${this.chat_id}`)
    } catch (error) {
      if ([403, 404].includes(error.http_code)) {
        this.error = error
        return
      }
      throw error
    }
  },
  methods: {
    open(){
      this.$refs.modal.open()
    },

    async goToChats(){
      $global.goToChats()
    },

    async duplicate(){
      this.copying = true
      try {
        const duplicate_id = await $chats.duplicateChat(this.chat_id)
        await $chats.load()
        $global.goToChat(duplicate_id)
      }
      catch (error) {
        if ([403, 404].includes(error.http_code)) {
          this.error = error
          return
        }
        throw error
      }
      finally {
        this.copying = false
      }
    },
  },
}
